/** A message reference is not a credential. The API still authenticates every
 * read. Handoff metadata stays in the URL fragment, never in request logs.
 */
export function isMailReference(value) {
  return typeof value === "string" && value.trim() === value
    && /^(?:[0-9]{1,20}:[0-9]{1,20}|v1\.[A-Za-z0-9_-]{1,2048}\.[0-9]{1,20}\.[0-9]{1,20})$/.test(value);
}

function safeValue(value, maximum) {
  return typeof value === "string" && value.length > 0 && value.length <= maximum
    && Array.from(value).every((char) => char.charCodeAt(0) >= 32 && char.charCodeAt(0) !== 127);
}

export function mailReaderHref(id, owner, connectionVersion) {
  if (!isMailReference(id) || !safeValue(owner, 128) || !safeValue(connectionVersion, 100)) return null;
  const fragment = new URLSearchParams({ message: id, owner, connection: connectionVersion });
  return `/settings/email-connections?view=message#${fragment.toString()}`;
}

export function parseMailReaderReference(hash, owner) {
  if (typeof hash !== "string" || hash.length > 4096 || !safeValue(owner, 128)) return null;
  const params = new URLSearchParams(hash.replace(/^#/, ""));
  if (Array.from(params.keys()).some((key) => !["message", "owner", "connection"].includes(key))) return null;
  if (["message", "owner", "connection"].some((key) => params.getAll(key).length !== 1)) return null;
  const id = params.get("message"), connection = params.get("connection");
  if (!isMailReference(id) || params.get("owner") !== owner || !safeValue(connection, 100)) return null;
  return { id, owner, connection };
}
